import {PriceStrategy} from "./PriceStrategy";
import {IOnInit} from "angular";

export const PriceInput = "tfPriceInput";

export function tfPriceInput() {
    return {
        template,
        bindings: {
            name: "@",
            price: "<",
            strategy: "<",
            disabled: "<",
            required: "<",
            min: "<",
            max: "<",
            allowZero: "<",
            onChange: "&"
        },
        controller: PriceInputComponentController,
        controllerAs: "ctrl"
    };
}

export class PriceInputComponentController implements IOnInit {

    public name: string;
    public price: number;
    public strategy: PriceStrategy;
    public disabled: boolean;
    public allowZero: boolean | null;
    public onChange: Function;

    public $onInit(): void {
        this.name = this.name || "price";
    }
}

const template = `
    <input type="text"
           name="{{ctrl.name}}"
           price-format="ctrl.strategy"
           price-step="ctrl.strategy"
           class="form-control"
           ng-change="ctrl.onChange({ price: ctrl.price })"
           ng-model="ctrl.price"
           ng-min="ctrl.min"
           ng-max="ctrl.max"
           ng-disabled="ctrl.disabled"
           ng-required="ctrl.required"
           value-not-zero="{{ctrl.name}}"
           value-not-zero-disabled="ctrl.allowZero"
           autocomplete="off">
`;
